import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    FooterComponent
  ],
  templateUrl: './app.component.html'
})
export class AppComponent {
  constructor(private router: Router) {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe(event => {
        const fullUrl = event.urlAfterRedirects;

        if (fullUrl.includes('redirect_url')) {
          const queryParam = this.router.parseUrl(event.urlAfterRedirects)?.queryParams['redirect_url'];

          if (queryParam) {
            const redirectUrl = `https://serp-ap.kalgudi.com/t/p/${queryParam}`;

            window.location.href = redirectUrl;
          }
        }
      });
  }
}